export default function openLink(href: string, isExternal: Boolean = true) {
  Object.assign(document.createElement('a'), {
    href,
    target: isExternal
      ? '_blank'
      : '_self'
  }).click()
}
